import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box } from '@mui/material';

import { CoreContext } from '../../../core/context/CoreContext';
import { useDispatch, useSelector } from 'react-redux';
import InventoryListTableHeader from './InventoryListTableHeader';
import InventoryListTableRow from './InventoryListTableRow';
import IconEnabled from 'core/components/layout/IconEnabled';

export default function InventoryListTable({ payload }) {

  const { showloading } = React.useContext(CoreContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const {userprofileInfo} = useSelector((state)=>state.headerslice);
  const {sorting} = useSelector((state)=>state.manufslice.inventoryDashboard)
  
  useEffect(() => {
    //if (rows.length===0)
      setRows(payload.tableList);
  }, [payload])

  useEffect(() => {
  if (sorting.column === 'productname') {
    setRows(prevRows =>
      [...prevRows].sort((a, b) => {
        const cmp = (a.productname || '').localeCompare(b.productname || '');
        return sorting.asc ? cmp : -cmp;
      })
    );
  }
  if (sorting.column === 'itemcount') {
  setRows(prevRows =>
    [...prevRows].sort((a, b) => {
      const aBalance = parseInt(a.itemcount, 10) || 0;
      const bBalance = parseInt(b.itemcount, 10) || 0;
      return sorting.asc ? aBalance - bBalance : bBalance - aBalance;
    })
  );
}
}, [sorting]);
  const handleRowClick = (rowId) => {
    setRows(prevData =>
      prevData.map(item =>
        item.id === rowId ? { ...item, 'expand': !item.expand } : item
      )
    );
  }

  const getActionComponent = (rowObj) => {
    return <>
      { payload.actionList
          .filter(actionObj => 
            <IconEnabled key={`${rowObj.id}-${actionObj.id}`} actionObj={actionObj} id={rowObj.id} />
          )
      }
    </>
  }

  return (
    <>
      <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", }}>
        {/* <HEADER/> */}
        <Grid item sx={{ width: '100%', paddingBottom: .2 }}>
          {/* <HEADER - CONTAINER/> */}
          < InventoryListTableHeader/>
        </Grid>
        {/* <ROWS/> */}
        <Grid item sx={{ width: '100%' }}>
          <Box lg={12} sx={{ flexGrow: 1 }}>
            <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '65vh' }}>
              {/* <ROW CONTAINER/> */}
              <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", width: '100%' }}>

              {rows.map(obj => {
                    return (
                      < InventoryListTableRow obj={obj} getActionComponent={getActionComponent} actionList={payload.actionList} handleRowClick={handleRowClick}/>
                    ) 
                })}
              {
                  rows.length === 0 ?
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ width: '100%', backgroundColor: '#fafafa' }}
                      padding={1}
                    >
                      <Typography sx={{ fontWeight: 'light', fontSize: 14 }}><i>Records(s) are not added, yet.</i></Typography>
                    </Grid>
                    : <></>
                }
               </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );


}